import React from "react";
import CustomCard from "../../../../../components/CustomCard";
import {
    BuildingModalIcon,
    CheckCardIcon
} from "../../../../../components/buttons/IconButtons";
import {EMPTY_VALUES, getDateFormat} from '../../../../../Apis/functions';
import {findGenderById} from "../../../../../enums/genderEnum";
import SuccessfullyEventDetails from "./SuccessfullyEventDetails";
import SuccessfullyRegisteredApp from "../Functionality/SuccessfullyRegisteredApp";

/**
 * RequestAccessSummary
 *
 * Component to display a summary of the QR request access form.
 * Shows visitor information, employee/host information, visit purpose,
 * and uploaded documents. Handles dynamic rendering of file cards with icons.
 *
 * @author Karen Yunuen Pozos Arias
 * @jobTitle Full Stack Developer - IBL
 * @email kpozos@ibl.mx
 *
 * @param {Function} t - Translation function from react-i18next
 * @param {Array} data - Array of selected visitors
 *
 * @returns {JSX.Element} The summary view of the request access form
 */

const SuccessfullyRegisteredVeridas = ({ data}) => {

    const {
        t,
        getPublicEventDetail,
        setLatitude,
        setLongitude,
        monthDay,
        latLng,
        direction,
        chipStatus
    } = SuccessfullyRegisteredApp();

    return (
        <div className={"d-grid gap-4 mb-4"}>
            <div className={"d-flex justify-content-center"}>
                <CheckCardIcon className={"icon-color-success-500"} height={54} width={54}/>
            </div>
            <div className="row">
                <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                    <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("you_have_been_successfully_registered")}</p>
                    <p className="fs-16-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("we_have_sent_your_invitation_by_email")}</p>
                    <p className="fs-16-to-14 ibl-font-w-400 font-color-general-950 text-center">
                        {t("please_check_your_inbox_or_spam_folder")}
                    </p>
                </div>
            </div>

            <CustomCard classes={"w-100"} classCard={'card-border-8px border-0 p-10px box-shadow-shades-150-4-12px'} classContent={'p-0 m-0'}>
                {/*HEADER*/}
                <div className={'d-flex align-items-center mb-2 justify-content-between'}>
                    <div className={"d-flex align-items-center"}>
                        <div className="icons-invitation-start">
                            <BuildingModalIcon className="w-100 h-100"/>
                        </div>

                        <p className={'fs-16-to-14 ibl-font-w-600 font-color-general-950 text-left pl-1'}>
                            {t("summary")}
                        </p>
                    </div>
                </div>
                <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>

                    <div className={'row my-2'}>

                        <div className={"col-12"}>
                            <p className={"font-color-general-950 ibl-font-w-600 fs-14-to-13 "}>{t("name")}</p>
                            <p className={"font-color-general-950 fs-14-to-13 "}>{ data?.name || EMPTY_VALUES.DEFAULT }</p>
                        </div>
                        <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                            <p className={"font-color-general-950 ibl-font-w-600 fs-14-to-13 "}>{t("last_name")}</p>
                            <p className={"font-color-general-950 fs-14-to-13 "}>{ data?.lastName || EMPTY_VALUES.DEFAULT }</p>
                        </div>

                        <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                            <p className={"font-color-general-950 ibl-font-w-600 fs-14-to-13 "}>{t("gender")}</p>
                            <p className={"font-color-general-950 fs-14-to-13 "}>{ t(findGenderById( data?.gender)?.name) || EMPTY_VALUES.DEFAULT }</p>
                        </div>

                        <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                            <p className={"font-color-general-950 ibl-font-w-600 fs-14-to-13 "}>{t("dob")}</p>
                            <p className={"font-color-general-950 fs-14-to-13 "}>{ getDateFormat(data?.dob, false) || EMPTY_VALUES.DEFAULT }</p>
                        </div>
                    </div>
                </CustomCard>
            </CustomCard>

            <SuccessfullyEventDetails
                latLng={latLng}
                t={t}
                setLatitude={setLatitude}
                setLongitude={setLongitude}
                getPublicEventDetail={getPublicEventDetail}
                direction={direction}
                chipStatus={chipStatus}
                monthDay={monthDay}
            />
        </div>
    );
};
export default SuccessfullyRegisteredVeridas
